import {
  computeQuoteLineTotals,
  formatCentsAsEuros,
  nr2jBillingPeriodSuffix,
  nr2jBillingTypeLabel,
  sumQuoteTotalsByBillingType,
} from './nr2jConstants.js';

/** Portée courte (miroir PDF) pour l’aperçu live. */
export function discountScopeAppliedLabel(billingType) {
  if (billingType === 'RECURRING_MONTHLY') return 'à chaque mensualité';
  if (billingType === 'RECURRING_YEARLY') return 'à chaque échéance annuelle';
  return 'une seule fois';
}

const BILLING_PREVIEW_ORDER = ['ONE_TIME', 'RECURRING_MONTHLY', 'RECURRING_YEARLY'];

/**
 * Construit les groupes d’aperçu live à partir des lignes éditeur locales.
 * @param {Array} lines
 * @param {(line: object, index: number) => object} lineToPayload
 */
export function buildNr2jQuoteLivePreviewGroups(lines, lineToPayload) {
  const payloads = (lines || []).map((l, i) => lineToPayload(l, i));
  const billingTotals = sumQuoteTotalsByBillingType(payloads);
  const byType = new Map();
  (lines || []).forEach((line, idx) => {
    const payload = payloads[idx];
    const computed = computeQuoteLineTotals(payload);
    const key = payload.billingType || 'ONE_TIME';
    const qty = Math.max(1, Number(payload.quantity) || 1);
    const unitInitial = payload.unitPriceHtCents;
    const unitAfter = Math.round(computed.lineHtCents / qty);
    const hasDiscount = computed.discountHtCents > 0;
    let discountValueLabel = null;
    if (hasDiscount) {
      if (line.discountMode === 'percent') {
        discountValueLabel = `${line.discountPercent || 0} %`;
      } else if (line.discountMode === 'fixed') {
        discountValueLabel = `${formatCentsAsEuros(computed.discountHtCents)} € HT`;
      } else if (payload.discountPercentBps != null) {
        discountValueLabel = `${Number(payload.discountPercentBps) / 100} %`;
      } else if (payload.discountAmountHtCents != null) {
        discountValueLabel = `${formatCentsAsEuros(payload.discountAmountHtCents)} € HT`;
      }
    }
    const entry = {
      key: line.key || `line-${idx}`,
      name: line.name?.trim() || `Ligne ${idx + 1}`,
      description: line.description?.trim() || '',
      quantity: qty,
      billingType: key,
      frequencyLabel: nr2jBillingTypeLabel(key),
      periodSuffix: nr2jBillingPeriodSuffix(key),
      hasDiscount,
      discountValueLabel,
      discountScopeLabel: discountScopeAppliedLabel(key),
      unitInitialCents: unitInitial,
      unitAfterCents: unitAfter,
    };
    if (!byType.has(key)) byType.set(key, []);
    byType.get(key).push(entry);
  });
  return BILLING_PREVIEW_ORDER.filter((k) => byType.has(k)).map((k) => {
    const block = billingTotals.find((b) => b.billingType === k);
    return {
      billingType: k,
      label: nr2jBillingTypeLabel(k),
      periodSuffix: nr2jBillingPeriodSuffix(k),
      items: byType.get(k),
      totals: block,
    };
  });
}
